export const calendarTabs = [
  {
    name: 'Earnings',
    slug: 'earnings',
    description:
      'Stay ahead of market moves with our real-time Earnings Calendar. Discover upcoming earnings reports with actionable insights to help you anticipate volatility and fine-tune your trade timing.',
  },
  {
    name: 'Economic Events',
    slug: 'economic-events',
    description:
      'Navigate market volatility like a pro. Track high-impact economic events and data releases with our calendar so you’re never caught off guard by sudden price swings.',
  },
  {
    name: 'IPOs',
    slug: 'ipos',
    description:
      'Be first to know about the hottest IPOs. Access key dates, filing details, and debut pricing so you can capitalize on market momentum before the crowd.',
  },
  {
    name: 'Dividends',
    slug: 'dividends',
    description:
      'Capture passive income with precision. Use our Dividends Calendar to find upcoming ex-dividend dates, payment schedules, and optimize income-focused strategies.',
  },
  {
    name: 'Splits',
    slug: 'splits',
    description:
      'Spot upcoming stock splits before they move the market. Our calendar helps you plan around key split dates and uncover opportunities in companies resetting share prices.',
  },
];
